document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector('.header__menu-btn');
  const mobileMenu = document.querySelector('.header__mobile-menu');
  const closeBtn = document.querySelector('.header__mobile-menu-close');
  const mobileNavLinks = document.querySelectorAll('.header__mobile-menu-list a[href^="#"]');

  // Mobile menu
  menuBtn.addEventListener('click', () => {
    mobileMenu.classList.add('is-open');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = "hidden"; // Prevent scrolling when menu is open
  });
  
  closeBtn.addEventListener('click', () => {
    mobileMenu.classList.remove('is-open');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = ""; // Re-enable scrolling
  });

  // Close mobile menu when clicking on a link
  mobileNavLinks.forEach((link) => {
    link.addEventListener("click", () => {
      mobileMenu.classList.remove("is-open");
      document.body.style.overflow = ""; // Re-enable scrolling
    });
  });

  // Logo click scrolls to top
  document.querySelector('.header__logo').addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  // Smooth scrolling for navigation links
  const navLinks = document.querySelectorAll(
    '.header__nav-list a[href^="#"], .header__mobile-menu-list a[href^="#"]',
  );

  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        const headerHeight = document.querySelector("header").offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });
  
  // Hero slider
  const slides = document.querySelectorAll('.hero__slide');
  let current = 0;
  
  setInterval(() => {
    slides[current].classList.remove('is-active');
    current = (current + 1) % slides.length;
    slides[current].classList.add('is-active');
  }, 5000);

  // Projetos slider
  const projetosSlider = document.querySelector(".projetos__slider");

  if (projetosSlider) {
    const track = projetosSlider.querySelector(".projetos__track");
    const projetosSlides = projetosSlider.querySelectorAll(".projetos__slide");
    const dots = projetosSlider.querySelectorAll(".projetos__dot");
    const AUTOPLAY_DELAY = 5000;
    const SWIPE_THRESHOLD = 50;

    let projetosIndex = 0;
    let autoplayId = null;

    const goToSlide = (index) => {
      projetosIndex = (index + projetosSlides.length) % projetosSlides.length;
      track.style.transform = `translateX(-${projetosIndex * 100}%)`;

      dots.forEach((dot, i) => {
        const isActive = i === projetosIndex;
        dot.classList.toggle("is-active", isActive);
        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const stopAutoplay = () => {
      clearInterval(autoplayId);
      autoplayId = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayId = setInterval(() => goToSlide(projetosIndex + 1), AUTOPLAY_DELAY);
    };

    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        goToSlide(i);
        startAutoplay();
      });
    });

    projetosSlider.addEventListener("mouseenter", stopAutoplay);
    projetosSlider.addEventListener("mouseleave", startAutoplay);

    // Swipe on touch devices
    let touchStartX = 0;

    projetosSlider.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      },
      { passive: true },
    );

    projetosSlider.addEventListener(
      "touchend",
      (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;

        if (Math.abs(delta) > SWIPE_THRESHOLD) {
          goToSlide(projetosIndex + (delta < 0 ? 1 : -1));
        }

        startAutoplay();
      },
      { passive: true },
    );

    goToSlide(0);
    startAutoplay();
  }

});